<div class="card mb-5 chart-wrapper">
  <div class="card-header" style="border-bottom: none;">
    <div class="card-title d-flex flex-column">
      <h4>{{ data.title | capitalCase }}</h4>
    </div>
  </div>
  <div class="card-body chart-body" [style.height]="resolvedHeight">
    <div [id]="data.widgetId" class="chart-host"></div>
  </div>
</div>
